export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್",
    "ancient_remedial_wisdom": "ಪ್ರಾಚೀನ ಪರಿಹಾರ ಬುದ್ಧಿವಂತಿಕೆ",
    "lal_kitab_description": "ವೈಯಕ್ತಿಕ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯೊಂದಿಗೆ ಪ್ರಾಚೀನ ಬುದ್ಧಿವಂತಿಕೆಯ ಜಗತ್ತಿನೊಳಗೆ ಹೆಜ್ಜೆ ಇಡಿ. ಗುಪ್ತ ಕಾರ್ಮಿಕ ಮಾದರಿಗಳನ್ನು ಬಹಿರಂಗಗೊಳಿಸಿ, ಜೀವನದ ರಹಸ್ಯಗಳನ್ನು ಅನಾವರಣಗೊಳಿಸಿ, ಮತ್ತು ಸವಾಲುಗಳನ್ನು ಯಶಸ್ಸು, ಸಾಮರಸ್ಯ ಮತ್ತು ಸಮೃದ್ಧಿಯ ಅವಕಾಶಗಳಾಗಿ ಪರಿವರ್ತಿಸಲು ಸರಳ ಆದರೆ ಶಕ್ತಿಶಾಲಿ ಪರಿಹಾರಗಳನ್ನು ಸ್ವೀಕರಿಸಿ.",

    "lal_kitab_title": "ಲಾಲ್ ಕಿತಾಬ್ ಜೊತೆಯಲ್ಲಿ",
    "craft_your_destiny": "ನಿಮ್ಮ ಭವಿತವ್ಯವನ್ನು ರೂಪಿಸಿ",

    // Service Information
    "enter_details_for_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_lal_kitab_analysis": "ಸಂಪೂರ್ಣ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_lal_kitab_analysis_note": "ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಕಾರ್ಮಿಕ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ವಿಸ್ತೃತ ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_lal_kitab_influence": "ನಿಮ್ಮ ಹೆಸರು ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಕಾರ್ಮಿಕ ಮಾದರಿಗಳು ಮತ್ತು ಪರಿಹಾರದ ಪರಿಣಾಮಕಾರಿತ್ವವನ್ನು ಪ್ರಭಾವಿಸುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_lal_kitab_chart": "ನಿಖರವಾದ ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್ ಮತ್ತು ಗ್ರಹಗಳ ವಿಶ್ಲೇಷಣೆ ಸೃಷ್ಟಿಸಲು ಅಗತ್ಯವಾದುದು",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_lal_kitab_houses": "ಲಾಲ್ ಕಿತಾಬ್ ವ್ಯವಸ್ಥೆಯಲ್ಲಿ ನಿಖರವಾದ ಭವನ ನಿಯೋಜನೆಗಳಿಗೆ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_lal_kitab_analysis": "ಸ್ಥಳವು ಗ್ರಹಗಳ ಸ್ಥಾನಗಳು ಮತ್ತು ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್ ಲೆಕ್ಕಾಚಾರಗಳ ಮೇಲೆ ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ನಿಮ್ಮ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ತಲುಪಿಸಲಾಗುವುದು",

    // Core Lal Kitab Features
    "lal_kitab_chart_analysis": "ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್ ವಿಶ್ಲೇಷಣೆ",
    "planetary_positions_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಗ್ರಹಗಳ ಸ್ಥಾನಗಳು",
    "practical_remedies_solutions": "ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಪರಿಹಾರಗಳು",
    "karmic_debts_analysis": "ಕಾರ್ಮಿಕ ಋಣಗಳ ವಿಶ್ಲೇಷಣೆ",
    "life_predictions_guidance": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯು ಏನನ್ನು ಒಳಗೊಂಡಿದೆ",
    "complete_lal_kitab_chart": "ಸಂಪೂರ್ಣ ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್",
    "practical_remedial_measures": "ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರ ಕ್ರಮಗಳು",
    "karmic_analysis_guidance": "ಕಾರ್ಮಿಕ ವಿಶ್ಲೇಷಣೆ ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "life_predictions_insights": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು ಮತ್ತು ಒಳನೋಟಗಳು",

    // Actions & Buttons
    "pay_and_get_lal_kitab_analysis": "ನನ್ನ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆಯನ್ನು ರಚಿಸಲಾಗುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "lal_kitab_analysis_processing": "ನಿಮ್ಮ ಸಮಗ್ರ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ತಜ್ಞ ಲಾಲ್ ಕಿತಾಬ್ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನೀವು ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಕಾರ್ಮಿಕ ಒಳನೋಟಗಳೊಂದಿಗೆ ವಿಸ್ತೃತ ಚಾರ್ಟ್ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಸ್ವೀಕರಿಸುವಿರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_24_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆ 24 ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತತ್ಕ್ಷಣ ಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ತಲುಪಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_lal_kitab_report": "ವಿಸ್ತೃತ ಲಾಲ್ ಕಿತಾಬ್ ವರದಿ (PDF)",
    "lal_kitab_chart_analysis": "ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್ ವಿಶ್ಲೇಷಣೆ",
    "practical_remedies_list": "ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರಗಳ ಪಟ್ಟಿ",
    "karmic_debts_solutions": "ಕಾರ್ಮಿಕ ಋಣಗಳು ಮತ್ತು ಪರಿಹಾರಗಳು",
    "life_guidance_predictions": "ಜೀವನ ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ಭವಿಷ್ಯವಾಣಿಗಳು",

    // Visual Content
    "sample_lal_kitab_analysis": "ಮಾದರಿ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆ",
    "lal_kitab_house_analysis": "ಲಾಲ್ ಕಿತಾಬ್ ಭವನ ವಿಶ್ಲೇಷಣೆ",
    "sample_lal_kitab_reading": "ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರ ಪರಿಹಾರಗಳೊಂದಿಗೆ ಬಲವಾದ ಗ್ರಹಗಳ ಸ್ಥಾನಗಳು",
    "sample_lal_kitab_preview": "ಪರಿಹಾರ ಮಾರ್ಗದರ್ಶನದೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "lal_kitab_houses": "ಲಾಲ್ ಕಿತಾಬ್ ಭವನಗಳು",

    // House Types
    "self": "ಸ್ವಯಂ",
    "wealth": "ಸಂಪತ್ತು",
    "siblings": "ಸಹೋದರ-ಸಹೋದರಿಯರು",
    "mother": "ತಾಯಿ",
    "children": "ಮಕ್ಕಳು",
    "enemies": "ಶತ್ರುಗಳು",
    "spouse": "ಜೀವನಸಂಗಾತಿ",
    "longevity": "ದೀರ್ಘಾಯುಷ್ಯ",
    "father": "ತಂದೆ",
    "career": "ವೃತ್ತಿ",
    "gains": "ಲಾಭಗಳು",
    "expenses": "ವೆಚ್ಚಗಳು",

    // Status & Processing
    "your_lal_kitab_analysis_status": "ನಿಮ್ಮ ಲಾಲ್ ಕಿತಾಬ್ ವಿಶ್ಲೇಷಣೆಯ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ಲಾಲ್ ಕಿತಾಬ್ ಚಾರ್ಟ್ ಅನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ತಜ್ಞ ಲಾಲ್ ಕಿತಾಬ್ ಜ್ಯೋತಿಷಿಗಳು ಪ್ರಾಯೋಗಿಕ ಪರಿಹಾರಗಳು ಮತ್ತು ಕಾರ್ಮಿಕ ಒಳನೋಟಗಳೊಂದಿಗೆ ನಿಖರವಾದ ವಿಶ್ಲೇಷಣೆಯನ್ನು ಒದಗಿಸಲು ನಿಮ್ಮ ಜನ್ಮ ಚಾರ್ಟ್ ಅನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸಾಲಿನಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_24_hours": "24 ಗಂಟೆಗಳೊಳಗೆ ವರದಿ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ಲಾಲ್ ಕಿತಾಬ್ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಇಲ್ಲಿ ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯವಾದ ಜನ್ಮ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಪ್ರಕ್ರಿಯೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Lal Kitab Specific Elements
    "planetary_debts": "ಗ್ರಹಗಳ ಋಣಗಳು",
    "karmic_accounts": "ಕಾರ್ಮಿಕ ಲೆಕ್ಕಗಳು",
    "ancestral_karma": "ಪೂರ್ವಜರ ಕರ್ಮ",
    "past_life_debts": "ಪೂರ್ವ ಜನ್ಮದ ಋಣಗಳು",
    "family_karma": "ಕುಟುಂಬದ ಕರ್ಮ",
    "collective_karma": "ಸಾಮೂಹಿಕ ಕರ್ಮ",

    // Planets in Lal Kitab
    "sun_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಸೂರ್ಯ",
    "moon_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಚಂದ್ರ",
    "mars_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಮಂಗಳ",
    "mercury_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಬುಧ",
    "jupiter_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಗುರು",
    "venus_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಶುಕ್ರ",
    "saturn_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಶನಿ",
    "rahu_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ರಾಹು",
    "ketu_lal_kitab": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಕೇತು",

    // Remedial Categories
    "simple_remedies": "ಸರಳ ಮನೆ ಪರಿಹಾರಗಳು",
    "donation_remedies": "ದಾನ ಮತ್ತು ದತ್ತಿ ಪರಿಹಾರಗಳು",
    "feeding_remedies": "ಆಹಾರ ಮತ್ತು ಸೇವೆಯ ಪರಿಹಾರಗಳು",
    "water_remedies": "ನೀರಿಗೆ ಸಂಬಂಧಿಸಿದ ಪರಿಹಾರಗಳು",
    "clothing_remedies": "ಉಡುಪು ಮತ್ತು ಬಣ್ಣದ ಪರಿಹಾರಗಳು",
    "behavioral_remedies": "ನಡವಳಿಕೆ ಬದಲಾವಣೆಯ ಪರಿಹಾರಗಳು",

    // Types of Debts
    "pitra_rin": "ಪಿತೃ ಋಣ (ಪೂರ್ವಜರ ಋಣ)",
    "matru_rin": "ಮಾತೃ ಋಣ (ತಾಯಿಯ ಋಣ)",
    "stree_rin": "ಸ್ತ್ರೀ ಋಣ (ಪತ್ನಿಯ ಋಣ)",
    "bhratru_rin": "ಭ್ರಾತೃ ಋಣ (ಸಹೋದರನ ಋಣ)",
    "putra_rin": "ಪುತ್ರ ಋಣ (ಮಗನ ಋಣ)",
    "guru_rin": "ಗುರು ಋಣ (ಗುರುವಿನ ಋಣ)",

    // Lal Kitab Concepts
    "blind_planets": "ಕುರುಡು ಗ್ರಹಗಳು",
    "lame_planets": "ಕುಂಟ ಗ್ರಹಗಳು",
    "sleeping_planets": "ಮಲಗುವ ಗ್ರಹಗಳು",
    "deceased_planets": "ಮೃತ ಗ್ರಹಗಳು",
    "enemy_planets": "ಶತ್ರು ಗ್ರಹಗಳು",
    "friend_planets": "ಮಿತ್ರ ಗ್ರಹಗಳು",

    // House Analysis
    "first_house": "1ನೇ ಭವನ - ವ್ಯಕ್ತಿತ್ವ ಮತ್ತು ಸ್ವಯಂ",
    "second_house": "2ನೇ ಭವನ - ಸಂಪತ್ತು ಮತ್ತು ಕುಟುಂಬ",
    "third_house": "3ನೇ ಭವನ - ಸಹೋದರರು ಮತ್ತು ಸಂವಹನ",
    "fourth_house": "4ನೇ ಭವನ - ತಾಯಿ ಮತ್ತು ಆಸ್ತಿ",
    "fifth_house": "5ನೇ ಭವನ - ಮಕ್ಕಳು ಮತ್ತು ಶಿಕ್ಷಣ",
    "sixth_house": "6ನೇ ಭವನ - ಶತ್ರುಗಳು ಮತ್ತು ಆರೋಗ್ಯ",
    "seventh_house": "7ನೇ ಭವನ - ಮದುವೆ ಮತ್ತು ಪಾಲುದಾರಿಕೆ",
    "eighth_house": "8ನೇ ಭವನ - ದೀರ್ಘಾಯುಷ್ಯ ಮತ್ತು ಅತೀಂದ್ರಿಯ",
    "ninth_house": "9ನೇ ಭವನ - ತಂದೆ ಮತ್ತು ಅದೃಷ್ಟ",
    "tenth_house": "10ನೇ ಭವನ - ವೃತ್ತಿ ಮತ್ತು ಸ್ಥಾನಮಾನ",
    "eleventh_house": "11ನೇ ಭವನ - ಲಾಭಗಳು ಮತ್ತು ಸ್ನೇಹಿತರು",
    "twelfth_house": "12ನೇ ಭವನ - ವೆಚ್ಚಗಳು ಮತ್ತು ವಿದೇಶ",

    // Planetary Strengths
    "strong_planets": "ಬಲವಾದ ಗ್ರಹಗಳು",
    "weak_planets": "ದುರ್ಬಲ ಗ್ರಹಗಳು",
    "malefic_planets": "ಅಶುಭ ಗ್ರಹಗಳು",
    "benefic_planets": "ಶುಭ ಗ್ರಹಗಳು",
    "neutral_planets": "ತಟಸ್ಥ ಗ್ರಹಗಳು",
    "exalted_planets": "ಉಚ್ಚ ಸ್ಥಾನದ ಗ್ರಹಗಳು",

    // Remedy Types
    "immediate_remedies": "ತತ್ಕ್ಷಣ ಪರಿಣಾಮದ ಪರಿಹಾರಗಳು",
    "long_term_remedies": "ದೀರ್ಘಾವಧಿಯ ಪರಿಹಾರಗಳು",
    "emergency_remedies": "ತುರ್ತು ಪರಿಹಾರಗಳು",
    "preventive_remedies": "ತಡೆಗಟ್ಟುವ ಪರಿಹಾರಗಳು",
    "corrective_remedies": "ತಿದ್ದುಪಡಿ ಪರಿಹಾರಗಳು",
    "protective_remedies": "ರಕ್ಷಣಾತ್ಮಕ ಪರಿಹಾರಗಳು",

    // Life Areas Analysis
    "health_analysis": "ಆರೋಗ್ಯ ವಿಶ್ಲೇಷಣೆ",
    "wealth_analysis": "ಸಂಪತ್ತಿನ ವಿಶ್ಲೇಷಣೆ",
    "career_analysis": "ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆ",
    "marriage_analysis": "ಮದುವೆ ವಿಶ್ಲೇಷಣೆ",
    "children_analysis": "ಮಕ್ಕಳ ವಿಶ್ಲೇಷಣೆ",
    "property_analysis": "ಆಸ್ತಿ ವಿಶ್ಲೇಷಣೆ",

    // Timing Analysis
    "favorable_periods": "ಅನುಕೂಲಕರ ಅವಧಿಗಳು",
    "challenging_periods": "ಸವಾಲಿನ ಅವಧಿಗಳು",
    "remedy_timing": "ಪರಿಹಾರ ಅನುಷ್ಠಾನ ಸಮಯ",
    "result_timing": "ನಿರೀಕ್ಷಿತ ಫಲಿತಾಂಶ ಸಮಯ",
    "life_phases": "ಪ್ರಮುಖ ಜೀವನ ಹಂತಗಳು",
    "turning_points": "ಜೀವನದ ತಿರುವು ಬಿಂದುಗಳು",

    // Special Features
    "curse_analysis": "ಶಾಪ ಮತ್ತು ಋಣಾತ್ಮಕ ಶಕ್ತಿ ವಿಶ್ಲೇಷಣೆ",
    "blessing_analysis": "ಆಶೀರ್ವಾದ ಮತ್ತು ಧನಾತ್ಮಕ ಶಕ್ತಿ",
    "family_tree_karma": "ಕುಟುಂಬ ವೃಕ್ಷ ಕರ್ಮ ವಿಶ್ಲೇಷಣೆ",
    "generational_patterns": "ತಲೆಮಾರಿನ ಕರ್ಮ ಮಾದರಿಗಳು",
    "soul_purpose": "ಆತ್ಮದ ಉದ್ದೇಶ ಮತ್ತು ಜೀವನ ಮಿಷನ್",
    "spiritual_evolution": "ಆಧ್ಯಾತ್ಮಿಕ ವಿಕಾಸ ಮಾರ್ಗ",

    // Practical Applications
    "daily_remedies": "ದೈನಂದಿನ ದಿನಚರಿ ಪರಿಹಾರಗಳು",
    "weekly_remedies": "ಸಾಪ್ತಾಹಿಕ ಆಚರಣೆಗಳು",
    "monthly_remedies": "ಮಾಸಿಕ ಅಭ್ಯಾಸಗಳು",
    "annual_remedies": "ವಾರ್ಷಿಕ ಆಚರಣೆಗಳು",
    "special_occasion_remedies": "ವಿಶೇಷ ಸಂದರ್ಭದ ಪರಿಹಾರಗಳು",
    "festival_remedies": "ಹಬ್ಬ ಆಧಾರಿತ ಪರಿಹಾರಗಳು",

    // Modern Adaptations
    "urban_remedies": "ನಗರ ಜೀವನ ಹೊಂದಾಣಿಕೆಗಳು",
    "office_remedies": "ಕೆಲಸದ ಸ್ಥಳದ ಪರಿಹಾರಗಳು",
    "travel_remedies": "ಪ್ರಯಾಣ ಮತ್ತು ಯಾತ್ರೆ ಪರಿಹಾರಗಳು",
    "technology_remedies": "ಆಧುನಿಕ ತಂತ್ರಜ್ಞಾನ ಪರಿಹಾರಗಳು",
    "social_media_remedies": "ಡಿಜಿಟಲ್ ಯುಗದ ಪರಿಹಾರಗಳು",
    "global_living_remedies": "ಅಂತರಾಷ್ಟ್ರೀಯ ಜೀವನ ಹೊಂದಾಣಿಕೆಗಳು",

    // Consultation Features
    "expert_consultation": "ತಜ್ಞ ಲಾಲ್ ಕಿತಾಬ್ ಸಮಾಲೋಚನೆ",
    "follow_up_guidance": "ಫಾಲೋ-ಅಪ್ ಪರಿಹಾರ ಮಾರ್ಗದರ್ಶನ",
    "progress_tracking": "ಪರಿಹಾರ ಪ್ರಗತಿ ಟ್ರ್ಯಾಕಿಂಗ್",
    "customization": "ವೈಯಕ್ತಿಕ ಪರಿಹಾರ ಕಸ್ಟಮೈಸೇಶನ್",
    "update_analysis": "ನವೀಕರಿಸಿದ ವಿಶ್ಲೇಷಣೆ ಆಯ್ಕೆಗಳು",
    "family_analysis": "ಕುಟುಂಬ ಚಾರ್ಟ್ ವಿಶ್ಲೇಷಣೆ",

    // Advanced Concepts
    "paap_planets": "ಪಾಪ (ಪಾಪಿ) ಗ್ರಹಗಳು",
    "punya_planets": "ಪುಣ್ಯ (ಸದ್ಗುಣಿ) ಗ್ರಹಗಳು",
    "raja_yoga": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ರಾಜ ಯೋಗ",
    "dhana_yoga": "ಧನ ಯೋಗ ಸಂಯೋಜನೆಗಳು",
    "vipreet_raja_yoga": "ವಿಪರೀತ ರಾಜ ಯೋಗ",
    "neech_bhang_yoga": "ನೀಚ ಭಂಗ ಯೋಗ",

    // Unique Lal Kitab Rules
    "pakka_ghar": "ಪಕ್ಕ ಘರ (ಶಾಶ್ವತ ಮನೆ)",
    "kachha_ghar": "ಕಚ್ಚ ಘರ (ತಾತ್ಕಾಲಿಕ ಮನೆ)",
    "mool_trikona": "ಲಾಲ್ ಕಿತಾಬ್‌ನಲ್ಲಿ ಮೂಲ ತ್ರಿಕೋಣ",
    "own_house": "ಸ್ವಂತ ಮನೆ ಸ್ಥಾನ",
    "friendly_house": "ಸ್ನೇಹಿ ಮನೆ ಸ್ಥಾನ",
    "enemy_house": "ಶತ್ರು ಮನೆ ಸ್ಥಾನ"
};
